import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const CompanyType = (props) => {
  const { t, isCentre, isClient, isHaulier, isSupplier, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === 1 ? 1 : "0.2"}>
        {isCentre && (
          <ColumnButton
            border="#00AEEA"
            background="#00AEEA"
            marginRight="10px"
          >
            {t("CENTRE")}
          </ColumnButton>
        )}
        {isClient && (
          <ColumnButton
            border="#00AEEA"
            background="#00AEEA"
            marginRight="10px"
          >
            {t("CLIENT")}
          </ColumnButton>
        )}
        {isHaulier && (
          <ColumnButton
            border="#00AEEA"
            background="#00AEEA"
            marginRight="10px"
          >
            {t("HAULIER")}
          </ColumnButton>
        )}
        {isSupplier && (
          <ColumnButton
            border="#00AEEA"
            background="#00AEEA"
            marginRight="10px"
          >
            {t("SUPPLIER")}
          </ColumnButton>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

CompanyType.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyType);
